import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
interface HeroSectionProps {
  onCtaClick: () => void;
}
export function HeroSection({
  onCtaClick
}: HeroSectionProps) {
  return <section className="pt-10 md:pt-14 pb-16 px-4 text-center max-w-5xl mx-auto" data-id="element-70" data-mp="23w38yfhma3ga">
      <motion.h1 initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="text-4xl md:text-6xl font-black text-brand-text mb-6 leading-[1.05] tracking-tight max-w-3xl mx-auto text-balance" data-id="element-71" data-mp="28tmm1c2kwa6n">
        Resolvé un año entero de clases de yoga en solo{' '}
        <span className="italic text-brand-green" data-id="element-72" data-mp="2ms32huq8tf1z">5 minutos</span>
      </motion.h1>

      <motion.p initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.06,
      ease: [0.23, 1, 0.32, 1]
    }} className="text-base md:text-lg text-brand-gray max-w-2xl mx-auto mb-8" data-id="element-73" data-mp="2rr604u3w8izx">
        Más de 1.200 profes argentinas ya dejaron de improvisar. Llegá a cada
        clase con todo listo para enseñar, profundizar y transformar.
      </motion.p>

      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.3,
      delay: 0.12,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative w-full max-w-3xl mx-auto mb-12" data-id="element-74" data-mp="2p5bniulsjmua">
        <img src="https://cdn.magicpatterns.com/uploads/f8Sn2MZXACJyjQceeF1DGS/ChatGPT_Image_13_jun_2026,_13_10_06-Photoroom.png" alt="Kit Yoga Lista: 5 tomos anuales, monitor, tablet y celular con las clases de yoga listas para usar." className="w-full h-auto object-contain" data-id="element-75" data-mp="2z1y61cqna1t5" />
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      delay: 0.18,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-76" data-mp="333a13xsaff8q">
        <CTAButton onClick={onCtaClick} className="mb-4" data-id="element-77" data-mp="18t6cf91c89ge">
          Quiero el Kit Yoga Lista
        </CTAButton>
        <p className="text-sm text-brand-gray font-medium" data-id="element-78" data-mp="38vo0ut01npcn">
          $19.990 pago único &middot; Descarga inmediata &middot; Acceso de por
          vida
        </p>
      </motion.div>
    </section>;
}